var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tvu-top-header', {
    ref: "tvuccHeader",
    attrs: {
      "projectName": _vm.$t('lang.title'),
      "globalFunList": _vm.activateFunList,
      "languageSwitcher": _vm.isActivate ? {} : {
        type: 'dropdown'
      }
    },
    on: {
      "callback": _vm.topHeaderCallback
    },
    scopedSlots: _vm._u([{
      key: "top-header-version",
      fn: function () {
        return [_c('div', [_vm._v(_vm._s(_vm.version))])];
      },
      proxy: true
    }, {
      key: "top-header-middle",
      fn: function () {
        return [!_vm.isActivate ? _c('div', {
          staticClass: "serviceSetting"
        }, [_c('a', {
          staticClass: "backBtn",
          attrs: {
            "href": _vm.switchUrl
          }
        }, [_vm._v(_vm._s(_vm.$t('lang.BackStr')))]), _c('span', {
          staticClass: "iconfont icon-shezhi1",
          attrs: {
            "title": _vm.$t('lang.TSetting')
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.goToPage({
                dataMark: 'st'
              });
            }
          }
        })]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "account-center-module",
      fn: function () {
        return [_vm.supportViewAccount && _vm.supportViewAccount !== '' ? _c('div', {
          staticClass: "switchSupport",
          on: {
            "click": function ($event) {
              return _vm.logout('changeToSupport');
            }
          }
        }, [_c('span', [_c('i', {
          staticClass: "iconfont"
        }, [_vm._v("")]), _vm._v(_vm._s(_vm.$t('lang.switchTo')) + " : " + _vm._s(_vm.supportViewAccount.supportUserEmail))])]) : _vm._e()];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }